export const sellerLevels = {
        0: 'no-level-seller',
        1: 'level-one-seller',
        2: 'level-two-seller',
        5: 'top-rated-seller'
    },
    levels = {
        'no-level-seller': 0,
        'level-one-seller': 1,
        'level-two-seller': 2,
        'top-rated-seller': 5
    };

export const getSellerClass = (level) => sellerLevels[level] || '';

export const getBadgeSize = (size) => {

    let badgeSize = 'lg';

    if (size < 51) {
        badgeSize = 'xs';
    } else if (size < 61) {
        badgeSize = 'sm';
    } else if (size < 111) {
        badgeSize = 'md';
    }

    return badgeSize;
};

const getSellerLevelKey = (level) => sellerLevels[level].replace(new RegExp('-', 'g'), '_');

export const getSellerLevelText = (sellerLevel, isPro, isLimitedEdition, isNewSeller) => {
    let sellerLevelText, sellerLevelTooltipText;

    switch (sellerLevel) {
        case 1:
        case 2:
        case 5:
            const levelKey = getSellerLevelKey(sellerLevel);
            sellerLevelText = `levels.${levelKey}.full_title`;
            sellerLevelTooltipText = `levels.${levelKey}.title_description`;
            break;
        default:
            if (isPro) {
                sellerLevelText = 'seller-levels.new-pro';
            } else if (isNewSeller) {
                sellerLevelText = 'seller-levels.new-seller';
            }
            break;
    }

    if (isLimitedEdition) {
        sellerLevelText = 'seller-levels.pro-spotlight-seller';
        sellerLevelTooltipText = `${sellerLevelText}-tooltip`;
    }

    if (!sellerLevelText) {
        return { sellerLevelTooltipText };
    }

    return {
        sellerLevelText,
        sellerLevelTooltipText
    };
};
